export const SET_IS_LOGGED_IN = 'SET_IS_LOGGED_IN';

export const SAVE_SESSION_TOKEN = 'SAVE_SESSION_TOKEN';

export const SET_LOGIN_ALERT_TYPE = 'SET_LOGIN_ALERT_TYPE';
